module.exports = __webpack_public_path__ + "static/media/cnn.com_2016_07_22_politics_dnc-wikileaks-emails_index.html_plot.16dbb7fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/cnn.com_2016_07_22_politics_dnc-wikileaks-emails_index.html_plot.png
// module id = 377
// module chunks = 0